import React, { useState, useEffect } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box, TextField, Typography } from '@mui/material';
import { Input, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { MonetizationOn, MonetizationOnOutlined, Money, Phone, SwipeUp, TextFields } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SearchInput from '../../SearchInput';
import CheckBox from '../../CheckBox';
import ModuleMappingBox from '../../ModuleMappingBox';
import RadioBox from '../../Radiox';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import DataType from '../../../Types/DataTablePiclist';
import Datas from '../../../Data/Data.json';


let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchCpt: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "plc2", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGroupUtilis: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

const columns: ColumnsType<any> = [
  {
    title: 'Code',
    dataIndex: 'Code',
    width: '20%'
  },
  {
    title: 'Libelle',
    dataIndex: 'Libelle',
  }];

interface Tab1Props {
  form?: any;
  disabled?: boolean;
  groupeData: {
    modules: string[];
    planCps: string[];
    groupInfo: any;
  };
  setModules: (modules: string[]) => void;
  setPlanCps: (planCps: string[]) => void;
  isConsultMode?: boolean;
  isAddMode?: boolean;
  isEditMode?: boolean;
}

function Tab1(props: Tab1Props) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  // USER TOKEN
  const authHeader = useAuthHeader()

  const [Data, SetData] = React.useState<DataType[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [error, setError] = useState<string | null>(null);


  const onSelectChange = (newSelectedRowKeys: any) => {
    setSelectedRowKeys(newSelectedRowKeys);
    const selectedCodes = newSelectedRowKeys.map((key: any) => {
      const item = Data.find((d: DataType) => d.key === key);
      return item ? item.Code : null;
    }).filter(Boolean);

    props.setPlanCps(selectedCodes);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };




  useEffect(() => {
    if (pageIsLoad) {
      setPageIsLoad(false);
      // loadPlanComptable();
    }
  }, [pageIsLoad]);

  useEffect(() => {
    if (Data.length > 0 && props.groupeData.planCps.length > 0) {
      syncSelectedRows();
    }
  }, [Data, props.groupeData.planCps]);

  const loadPlanComptable = () => {
    setLoading(true);
    setError(null);
    const datat: DataType[] = [];

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(searchPlanCpte))
      }
    };

    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            let datas = res.Result.Table;

            if (datas.length === 0) {
              SetData(datat);
            } else {
              datas.map((data: any, indice: number) => {
                datat.push({
                  key: indice,
                  Code: data[Object.keys(data)[1]],
                  Libelle: data[Object.keys(data)[0]],
                });
              });
              SetData(datat);
            }
          } else {
            setError('Erreur lors du chargement des données');
          }
        }
      })
      .catch((error) => {
        console.error('Error loading plan comptable:', error);
        setError('Erreur de connexion au serveur');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const syncSelectedRows = () => {
    const selectedKeys: React.Key[] = [];
    props.groupeData.planCps.forEach((planCp: string) => {
      const item = Data.find((d: DataType) => d.Code === planCp);
      if (item) {
        selectedKeys.push(item.key);
      }
    });
    setSelectedRowKeys(selectedKeys);
  };




  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Box fontStyle={'inherit'} display={"flex"}>


            <Box width={'40%'}>
              {/* <Box display={"flex"} fontStyle="inherit" className='border-left'> */}
              {/* <CheckBox form = {props.form}   label='Frais de relevé de compte obligatoire pour le plan comptable ? ' name='ISFRAIHNEED'/> */}
              {/* <Typography className='top19'>Frais de relevé de compte obligatoire pour le plan comptable ?</Typography>
                <RadioBox name={'COSTBYPAGE'} Value1={"true"} Value2={"false"} LibValue1={'Par page'} libVlue2={'Pour tous les relevés'} />
              </Box> */}
              {/* <Box display="flex" fontStyle="inherit" className='border-left'>
                <Spin spinning={loading}>
                  {error && (
                    <Typography color="error" style={{ marginBottom: 10 }}>
                      {error}
                    </Typography>
                  )}
                  <Table 
                    size='small' 
                    style={{ width: 'auto' }} 
                    rowSelection={{ 
                      ...rowSelection, 
                      type: "checkbox",
                      getCheckboxProps: (record: any) => ({
                        disabled: props.disabled || props.isConsultMode
                      })
                    }} 
                    columns={columns} 
                    dataSource={Data} 
                    scroll={{ y: 300, x: 10 }} 
                    pagination={false} 
                  />
                </Spin>
              </Box> */}
              <Box fontStyle="inherit" className='border-left'>
                {/* <SearInputM  width={4} form = {props.form}  Titre='Recherche Utilisateur'  label='Code' name='coduti' Parametre={searchUser}/> */}
                <SearchInput notremove dissabledLib={props.disabled} width={6} form={props.form} Titre='Recherche Groupe Utilisateur' label='Code' name='codgroup' Parametre={searchGroupUtilis} />
                {/* <InputForm width={6} label='Libellé' icon={<TextFields fontSize='small'/>}   name='libelle'  type='text' error='mobile' /> */}
                <InputForm width={6} label='Niveau' icon={<SwipeUp fontSize='small' />} name='niveau' type='number' error='mobile' />
              </Box>
            </Box>
            <Box width={'60%'} fontStyle="inherit" className='border-left'>
              <ModuleMappingBox
                selectedModules={props.groupeData.modules}
                onModulesChange={props.setModules}
                disabled={props.disabled || props.isConsultMode}
                isConsultMode={props.isConsultMode}
                title="Modules relatifs au groupe"
              />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}

export default Tab1;  
